import { ConfigProvider } from "antd";
import "antd/dist/reset.css";
import locale from "antd/lib/locale/vi_VN";
import "assets/css/app.scss";
import "assets/font/iconmon/font.css";
import store from "domain/store";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "assets/css/_inventoryTable.scss";

window.addEventListener("error", (e) => {
  if (e.message === "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded") {
    e.stopImmediatePropagation();
  }
});

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={locale}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
